import { DropShipSource } from "helper/constant";
import List from "../list"

const DropShippingList = () => {

    return (
        <List source={DropShipSource.xffbb} />
    );
};


export default DropShippingList;
